<template>
    <div id="homeBox">
        <div class="flexcenter">
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-plus"  @click="add">新增</el-button>

            <div style="margin-right: 20px">
                <el-input
                        size="mini"
                        style="width: 200px  "
                        placeholder="请输入搜索内容"
                        v-model="Searchdata"
                        clearable>
                </el-input>
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="SearchConsumer" size="mini"></el-button>
            </div>
        </div>
        <el-table
                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    show-overflow-tooltip>
            </el-table-column>
            <!--        <el-table-column-->
            <!--                prop="ywlx"-->
            <!--                label="业务类型"-->
            <!--                show-overflow-tooltip>-->
            <!--        </el-table-column>-->

            <el-table-column
                    prop="name"
                    label="服务名称"
                    show-overflow-tooltip>
            </el-table-column>
            <!--        <el-table-column-->
            <!--                prop="consumerServerName"-->
            <!--                label="消费服务名称"-->
            <!--                show-overflow-tooltip>-->
            <!--        </el-table-column>-->
            <el-table-column
                    prop="destination"
                    label="目的地"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column

                    label="消费类型"
                    show-overflow-tooltip>
                <template slot-scope="scope" >
                    <span v-if="scope.row.type=='0'">私有</span>
                    <span v-if="scope.row.type=='1'">公共</span>

                </template>
            </el-table-column>

            <el-table-column
                    prop="lruname"
                    label="录入人"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="创建时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    width="100"
                    label="操作">
                <template slot-scope="scope" >

                    <el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
                    <el-button style="color:red;"  type="text" size="mini" @click="del(scope.row)">删除</el-button>

                </template>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">

                    </el-pagination>
                </div>

            </div>
        </div>
        <el-dialog
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                :close-on-click-modal="false"
                top="2.143rem"width="31.429rem"
                height="300"
                :title="title"
                :visible.sync="bianjipingtai"
                v-if="bianjipingtai"
        >
            <consumer-entry @getConsumerServerInfoList="getConsumerServerInfoList" :editData="editData" @close="close"></consumer-entry>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delDialogVisible"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delDialogVisible"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import ConsumerEntry from "./component/ConsumerEntry";
    export default {
        name: 'consumerServe',
        components:{
            ConsumerEntry
        },
        data(){
            return{
                bianjipingtai:false,  //编辑弹框
                Searchdata:'',//搜索内容
                currentPage:1,
                pageSize:10,
                total:0,
                tableData: [],
                tableHeight:0,//列表高度
                title:'',
                editData:{},//编辑数据
                delDialogVisible:false,  //删除弹框
                deldetail:'',//删除提示信息
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.$nextTick(()=>{
                this.onResize();

            })

            // this.$nextTick(function () {
            //     window.addEventListener('resize',this.heightAuto);
            //     this.heightAuto();
            // });
            //获取列表
            this.getConsumerServerInfoList()
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            //新增
            add(){
                this.title='新增'
                this.editData={
                    id:0,
                    name:'',
                    destination:'',
                    type:'',
                    lruname:sessionStorage.getItem('lruname'),
                }
                this.bianjipingtai=true
            },
            //编辑
            edit(val){
                this.title='编辑'
                this.editData=val
                this.bianjipingtai=true
                this.editData=Object.assign({},val);
                // console.log(this.editData)
            },
            //搜索
            SearchConsumer(){
                this.getConsumerServerInfoList()
                this.currentPage=1
            },
            //确认删除
            submitdel(){
                this.delConsumerServerInfo()

                this.delDialogVisible=false

            },
            //删除
            del(val){
                this.editData=val
                this.validateConsumerUser()

            },
            //关闭弹框
            close(){
                this.bianjipingtai=false
            },
            //消费信息列表查询
            async getConsumerServerInfoList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:this.Searchdata,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }
                let res = await API.getConsumerServerInfoList(params);
                if (res.code == 1) {
                    this.tableData=res.list
                    this.total=res.total

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //消费服务详情删除
            async delConsumerServerInfo() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id
                }
                let res = await API.delConsumerServerInfo(params);
                if (res.code == 1) {
                    if(this.tableData.length==1){
                        this.currentPage=1

                    }
                    this.getConsumerServerInfoList()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //消费服务是否使用验证
            async validateConsumerUser() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id
                }
                let res = await API.validateConsumerUser(params);
                if (res.code == 1) {
                    this.delDialogVisible=true
                    this.deldetail='是否要删除'

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    // this.$message.error(res.message);

                    this.delDialogVisible=true
                    this.deldetail=res.message
                } else {
                    // this.$message.error(res.message);

                    this.delDialogVisible=true
                    this.deldetail=res.message
                }
            },
            //消费服务下拉查询
            async getConsumerServerDropDownList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {

                }
                let res = await API.getConsumerServerDropDownList(params);
                if (res.code == 1) {

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //消费服务详情查询
            async getConsumerServerDetail() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id
                }
                let res = await API.getConsumerServerDetail(params);
                if (res.code == 1) {

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getConsumerServerInfoList()

            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val;    //动态改变
                this.getConsumerServerInfoList()

            },
            //高度
            heightAuto(){
                this.tableHeight = window.innerHeight -  document.getElementById('body').getBoundingClientRect().top -100;
            },
            beforeDestroy() {
                window.removeEventListener('resize',this.heightAuto)
            },
        },

    }
</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width:610px !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
</style>